import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertError16Icon extends BaseIcon {
  getChildren = () => [
    <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z" fill="#f24e4e"/>,
    <path d="M11.7 10.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L8 9.4l-2.3 2.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L6.6 8 4.3 5.7c-.4-.4-.4-1 0-1.4s1-.4 1.4 0L8 6.6l2.3-2.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L9.4 8l2.3 2.3z" fill="#fff"/>
    ]
  getViewBox = () => '0 0 16 16'
}
